import {
  Children,
  isValidElement,
  type PropsWithChildren,
  type ReactNode,
} from 'react';

import { isSlot } from '../../../../../core/utils/is-slot.js';
import { TrackAtom } from '../slots/TrackAtom.js';

/**
 * Extract all visible TrackAtom components,
 * checking deeper in case they are grouped into a wrapper component
 *
 * @param elements -
 */
export function extractVisibleTracks(children: ReactNode): ReactNode[] {
  const elementsArray: ReactNode[] = [];
  Children.forEach(children, (child) => {
    if (isSlot(child, TrackAtom)) {
      if (!child.props.hidden) {
        elementsArray.push(child);
      }
    } else if (isValidElement<PropsWithChildren>(child)) {
      elementsArray.push(...extractVisibleTracks(child.props.children));
    }
  });

  return elementsArray;
}
